import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-institutions-create',
  templateUrl: './institutions-create.component.html',
  styleUrls: ['./institutions-create.component.scss']
})
export class InstitutionsCreateComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string, private ActivatedRoute: ActivatedRoute, private router: Router,) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

  ngOnInit() {
    this.Form = this.formBuilder.group({
      institution: ['', Validators.required],
      heading1: ['', Validators.required],
      description1: ['', [Validators.required]],
      heading2: ['', Validators.required],
      description2: ['', [Validators.required]],
      heading2image: ['', Validators.required],
      metatitle: ['', Validators.required],
      metakeyword: ['', Validators.required],
      metadesc: ['', Validators.required],
      /* content1image: ['', [Validators.required]],
      content2image: ['', Validators.required],
      content3image: ['', [Validators.required]],
      content1: ['', Validators.required],
      content2: ['', [Validators.required]],
      content3: ['', Validators.required], */
      _id: [''],
    });
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    this.http.get<any>(this.api_endpoint+'/ourinstitutionsbyid/' + `${id}`).subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              institution: data.data.institution,
              heading1: data.data.heading1,
              description1: data.data.description1,
              heading2: data.data.heading2,
              description2: data.data.description2,
              heading2image: data.data.heading2image,
              metatitle: data.data.metatitle,
              metakeyword: data.data.metakeyword,
              metadesc: data.data.metadesc,
              /* content1image: data.data.content1image,
              content2image: data.data.content2image,
              content3image: data.data.content3image,
              content1: data.data.content1,
              content2: data.data.content2,
              content3: data.data.content3, */
              _id: data.data._id,
            })
          }else{
            this.action = 'Submit';
            this.Form.patchValue({
              institution: '',
              heading1: '',
              description1: '',
              heading2: '',
              description2: '',
              heading2image: '',
              metatitle: '',
              metakeyword: '',
              metadesc: '',
              /* content1image: '',
              content2image: '',
              content3image: '',
              content1: '',
              content2: '',
              content3: '', */
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){
    console.log(this.Form.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "institution"      : this.Form.value.institution,
        "heading1"      : this.Form.value.heading1,
        "description1"  : this.Form.value.description1,
        "heading2"      : this.Form.value.heading2,
        "description2"  : this.Form.value.description2,
        "heading2image"       : this.Form.value.heading2image,
        "metatitle": this.Form.value.metatitle,
        "metakeyword": this.Form.value.metakeyword,
        "metadesc": this.Form.value.metadesc,
        /* "content1image"       : this.Form.value.content1image,
        "content2image"       : this.Form.value.content2image,
        "content3image"       : this.Form.value.content3image,
        "content1"       : this.Form.value.content1,
        "content2"       : this.Form.value.content2,
        "content3"       : this.Form.value.content3, */
        "admin" : sessionStorage.getItem('adminName'),
        "_id"           : this.Form.value._id,
      };
      this.http.put<any>(this.api_endpoint+'/ourinstitutions', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/institutions/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "institution"      : this.Form.value.institution,
        "heading1"      : this.Form.value.heading1,
        "description1"  : this.Form.value.description1,
        "heading2"      : this.Form.value.heading2,
        "description2"  : this.Form.value.description2,
        "heading2image"       : this.Form.value.heading2image,
        "metatitle": this.Form.value.metatitle,
        "metakeyword": this.Form.value.metakeyword,
        "metadesc": this.Form.value.metadesc,
        /* "content1image"       : this.Form.value.content1image,
        "content2image"       : this.Form.value.content2image,
        "content3image"       : this.Form.value.content3image,
        "content1"       : this.Form.value.content1,
        "content2"       : this.Form.value.content2,
        "content3"       : this.Form.value.content3, */
        "admin" : sessionStorage.getItem('adminName'),
      };
      this.http.post<any>(this.api_endpoint+'/ourinstitutions', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/institutions/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
